import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";
import {Publisher} from "./publisher.model";
import {Measure} from "./measure.model";

@Model('productBook')
export class ProductBook extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  isbn: string | undefined;
  @Column()
  isbn10: string | undefined;
  @Column()
  title: string | undefined;
  @Column()
  subtitle: string | undefined;
  @Column()
  blurb: string | undefined;
  @Column()
  language: string | undefined;
  @Column()
  description: string | undefined;
  @Column({column: 'numpagescolor'})
  colorPages: string | undefined;
  @Column({column: 'numpages'})
  numberOfPages: number | undefined;
  @Column()
  colorPagePosition: string | undefined;
  @Column()
  hardcover: boolean | undefined;
  @Column()
  publishedAt: Date | undefined;
  @Column()
  publisher: Publisher | undefined = new Publisher();
  @Column()
  measure: Measure | undefined = new Measure();

}
